import { useContext } from 'react';
import { PresentationIcon } from 'lucide-react';
import { toast } from 'sonner';

import { DropdownMenuCheckboxItem } from '@/components/ui/dropdown-menu';
import { PageAccessCtx } from '@/hooks/page-access-context';
import { useAuth } from '@/hooks/use-auth';

/**
 * A superadmin's switch for presenting a workspace as its members see it. Demo mode acts
 * through the superadmin's own membership, so it needs one in the current workspace.
 */
export function DemoModeMenuItem() {
  const { setDemoMode: setSessionDemoMode, user } = useAuth();
  // Outside a page that tracks its access there is no page to keep in step.
  const setDemoMode = useContext(PageAccessCtx)?.setDemoModeHere ?? setSessionDemoMode;
  if (user === null || (!user.is_superadmin && !user.demo_mode)) return null;

  const canStart = user.membership_id !== null;
  return (
    <DropdownMenuCheckboxItem
      checked={user.demo_mode}
      disabled={!user.demo_mode && !canStart}
      onCheckedChange={(enabled) => {
        setDemoMode(enabled).catch(() => {
          toast.error(enabled ? 'Demo mode could not be started.' : 'Demo mode could not be stopped.');
        });
      }}
    >
      <PresentationIcon data-icon="inline-start" />
      <span className="flex flex-col">
        Demo mode
        {canStart ? null : (
          <span className="text-xs text-muted-foreground">Join this workspace first</span>
        )}
      </span>
    </DropdownMenuCheckboxItem>
  );
}
